import React from 'react';
import { renderTotalPayLabel } from '../services';
import { getHygienistPayDisplayData } from '../services/hygienistPayCalculator';
import HygienistPayAsterisk from './HygienistPayAsterisk';

/**
 * Total pay cell with optional hygienist billable care display.
 * Shows total pay label with asterisk notation when hygienist billable care > 0.
 * 
 * @component
 * @param {object} props - Component props
 * @param {object} props.row - Provider row data
 * @param {string} props.calendarRedirectUrl - URL for calendar redirect
 * @param {object} props.pracHynBillableCareTotal - Practice hygienist care totals
 * @param {boolean} props.showAsterisk - Whether to show asterisk notation
 * @returns {JSX.Element} Table cell with pay information
 */
const TotalPayCell = ({
    row,
    calendarRedirectUrl,
    pracHynBillableCareTotal,
    showAsterisk,
    useAccountFilteredPay = false
}) => {
    // Get hygienist pay data with validation (only if hygBillableCare > 0)
    const hygDisplayData = getHygienistPayDisplayData(row, pracHynBillableCareTotal);
    
    return (
        <td>
            {renderTotalPayLabel(row, calendarRedirectUrl, useAccountFilteredPay)}
            {showAsterisk && (
                <HygienistPayAsterisk 
                    calculatedPay={hygDisplayData.calculatedPay}
                    shouldDisplay={hygDisplayData.shouldDisplay}
                />
            )}
        </td>
    );
};

export default TotalPayCell;
